export const offers = {
  list_title: "Promociones",
  list_cta: "Crear promoción",
  list_empty_title: "Aún no tienes promociones",
  list_empty_description: "Crea tu primera promoción para atraer más clientes con descuentos en productos o categorías.",
  search_placeholder: "Buscar promoción",
  reload: "Recargar",
  filters: {
    active: "Activas",
    expired: "Expiradas",
    scheduled: "Programadas",
    disabled: "Deshabilitadas",
  },
  status: {
    active: "Activa",
    expired: "Expirada",
    scheduled: "Programada",
    disabled: "Deshabilitada",
  },
  card: {
    products: "{{count}} productos",
    categories: "{{count}} categorías",
    all_products: "Todos los productos",
    all_categories: "Todas las categorías",
    discount: "Descuento",
    always_available: "Siempre disponible",
    valid_from: "Desde {{date}}",
    valid_until: "Hasta {{date}}",
    valid_range: "{{start}} - {{end}}",
  },
  delete_modal: {
    title: "Eliminar promoción",
    description: "¿Estás seguro de que deseas eliminar esta promoción? Esta acción no se puede deshacer.",
    cancel: "Cancelar",
    delete: "Eliminar",
  },
  expired_modal: {
    title: "Promoción expirada",
    description: "Esta promoción ya expiró. Puedes editarla para extender las fechas o eliminarla.",
    edit: "Editar",
    delete: "Eliminar",
  },
  wizard: {
    title_create: "Crear promoción",
    title_edit: "Editar promoción",
    steps: {
      selector: "Productos",
      discount: "Descuento",
      form: "Información",
    },
    back: "Atrás",
    continue: "Continuar",
    save: "Guardar promoción",
    create: "Crear promoción",
  },
  selector: {
    products_tab: "Productos",
    categories_tab: "Categorías",
    search_products: "Buscar producto",
    search_categories: "Buscar categoría",
    select_all: "Seleccionar todos",
    no_products: "No tienes productos disponibles",
    no_categories: "No tienes categorías disponibles",
    products_count: "{{count}} productos",
    product_status: {
      inactive: "Inactivo",
      sold_out: "Agotado",
      active_offer: "En otra oferta",
    },
  },
  discount: {
    mode_bulk: "Descuento masivo",
    mode_individual: "Descuento individual",
    type_percentage: "Porcentaje",
    type_value: "Valor fijo",
    bulk_label: "Descuento para todos",
    price_with_discount: "Precio con descuento",
  },
  form: {
    name: "Nombre de la promoción",
    name_placeholder: "Ej: Oferta de verano",
    description: "Descripción",
    description_placeholder: "Describe tu promoción",
    schedule_dates: "Programar fechas",
    start_date: "Fecha de inicio",
    end_date: "Fecha de fin",
    products_section: "Productos incluidos",
    categories_section: "Categorías incluidas",
  },
  detail: {
    title: "Detalle de promoción",
    edit: "Editar",
    discount_type: "Tipo de descuento",
    dates: "Fechas",
    no_dates: "Sin fechas programadas",
    products: "Productos",
    categories: "Categorías",
  },
  messages: {
    created: "Promoción creada correctamente",
    updated: "Promoción actualizada correctamente",
    deleted: "Promoción eliminada",
    error_save: "No se pudo guardar la promoción",
    error_delete: "No se pudo eliminar la promoción",
    error_load: "No se pudieron cargar las promociones",
    validation_name: "El nombre es obligatorio",
    validation_discount: "Revisa los descuentos ingresados",
    validation_selection: "Selecciona al menos un producto o categoría",
  },
};
